import './styles.css';
import { useRef } from 'react';

import ReviewsSessionExerciseTable from '../exerciseTable';
import { gameTypeLabelsReversed } from './data';

export default function GamesPreviewModal ({ 
  onClose,
  roundRows,
  tournamentRoundGames = [],
  onGameSelectChange,
  selectButtonText,
  selectButtonTextChanged,
  onSelectButtonClick,
  title,
  onImDoneButtonClick,
  isImDoneButtonLoading
}) {
  const modalRef = useRef(null);

  const tournamentGames = tournamentRoundGames.map(game => ({
    id: game.game_id,
    type: gameTypeLabelsReversed[game.gameType]
  }));

  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose?.();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal review-session-games-preview-modal" ref={modalRef}>
        {onClose && (
          <button
            type="button"
            className="games-preview-modal-close"
            aria-label="Close"
            onClick={onClose}
          >
            ×
          </button>
        )}
        <h3>{title}</h3>
        <ReviewsSessionExerciseTable 
          rows={roundRows}
          tournamentGames={tournamentGames}
          withWrapper={false}
          selectButtonTextChanged={selectButtonTextChanged}
          selectButtonText={selectButtonText}
          onSelectButtonClick={onSelectButtonClick}
          onSelectChange={onGameSelectChange}
        />
        {
          onImDoneButtonClick && 
            <button 
              className={`button-navi ${isImDoneButtonLoading ? 'loading' : ''}`}
              onClick={onImDoneButtonClick}
            >
              {!isImDoneButtonLoading && 'I’m done'}
            </button>
        }
      </div>
    </div>
  );
};